export default __webpack_public_path__ + "static/media/webcam8.317040e9.jfif";